import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'
import Languages from '../Lang';
import { Link } from 'react-router-dom';

// That's Will Render The Navbar 
export default function Navbar({ activeMnueLang, setActiveMnueLang }) {

    const choosedLang = localStorage.getItem('lang') === "Arabic" ? 'العربيه' : localStorage.getItem('lang');

    useEffect(() => {

        window.addEventListener('click', _ => setActiveMnueLang(false));

        // // Clean up
        return () => window.removeEventListener('click', setActiveMnueLang);

    }, []);

    return (

        <div className='p-2 bg-[var(--off-white)]'>

            <div className='container relative flex items-center justify-between'>


                <div className='flex items-center'>

                    <div className='flex items-center'>


                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.36797 15.1693C5.1213 15.1693 5.91464 14.9893 6.73464 14.6426C7.53464 14.3026 8.3413 13.8359 9.12797 13.2693C9.90797 12.6959 10.6613 12.0559 11.3746 11.3559C12.0813 10.6426 12.7213 9.88927 13.288 9.11594C13.8613 8.31594 14.3213 7.51594 14.648 6.7426C14.9946 5.91594 15.168 5.11594 15.168 4.3626C15.168 3.8426 15.0746 3.34927 14.8946 2.88927C14.708 2.41594 14.408 1.97594 14.0013 1.59594C13.488 1.08927 12.9013 0.835938 12.2746 0.835938C12.0146 0.835938 11.748 0.895938 11.5213 1.0026C11.2613 1.1226 11.0413 1.3026 10.8813 1.5426L9.33464 3.7226C9.19464 3.91594 9.08797 4.1026 9.01464 4.28927C8.92797 4.48927 8.8813 4.68927 8.8813 4.8826C8.8813 5.13594 8.95464 5.3826 9.09464 5.61594C9.19464 5.79594 9.34797 5.98927 9.5413 6.1826L9.99464 6.65594C9.98797 6.67594 9.9813 6.68927 9.97464 6.7026C9.89464 6.8426 9.73464 7.0826 9.42797 7.4426C9.1013 7.81594 8.79463 8.15594 8.48797 8.46927C8.09464 8.85594 7.76797 9.1626 7.4613 9.41594C7.0813 9.73594 6.83463 9.89594 6.68797 9.96927L6.7013 10.0026L6.21463 9.5226C6.00797 9.31594 5.80797 9.1626 5.61464 9.0626C5.24797 8.83594 4.7813 8.79594 4.31463 8.98927C4.1413 9.0626 3.95463 9.1626 3.75463 9.3026L1.5413 10.8759C1.29463 11.0426 1.11464 11.2559 1.00797 11.5093C0.907969 11.7626 0.861302 11.9959 0.861302 12.2293C0.861302 12.5493 0.934635 12.8693 1.07464 13.1693C1.21464 13.4693 1.38797 13.7293 1.60797 13.9693C1.98797 14.3893 2.4013 14.6893 2.8813 14.8826C3.3413 15.0693 3.8413 15.1693 4.36797 15.1693ZM12.2746 1.83594C12.6413 1.83594 12.9813 1.99594 13.308 2.31594C13.6146 2.6026 13.828 2.91594 13.9613 3.25594C14.1013 3.6026 14.168 3.96927 14.168 4.3626C14.168 4.9826 14.0213 5.65594 13.728 6.34927C13.428 7.05594 13.008 7.78927 12.4746 8.5226C11.9413 9.25594 11.3346 9.96927 10.668 10.6426C10.0013 11.3026 9.2813 11.9159 8.5413 12.4559C7.8213 12.9826 7.0813 13.4093 6.34797 13.7159C5.20797 14.2026 4.1413 14.3159 3.2613 13.9493C2.9213 13.8093 2.6213 13.5959 2.34797 13.2893C2.19464 13.1226 2.07463 12.9426 1.97463 12.7293C1.89463 12.5626 1.85464 12.3893 1.85464 12.2159C1.85464 12.1093 1.87463 12.0026 1.92797 11.8826C1.94797 11.8426 1.98797 11.7693 2.11464 11.6826L4.32797 10.1093C4.4613 10.0159 4.5813 9.94927 4.69464 9.90261C4.8413 9.8426 4.9013 9.7826 5.12797 9.9226C5.2613 9.98927 5.3813 10.0893 5.51464 10.2226L6.0213 10.7226C6.2813 10.9759 6.6813 11.0359 6.98797 10.9226L7.16797 10.8426C7.4413 10.6959 7.7613 10.4693 8.11464 10.1693C8.43464 9.89594 8.7813 9.57594 9.2013 9.1626C9.52797 8.82927 9.85464 8.47594 10.1946 8.0826C10.508 7.71594 10.7346 7.4026 10.8746 7.1426L10.9546 6.9426C10.9946 6.78927 11.008 6.7026 11.008 6.60927C11.008 6.36927 10.9213 6.15594 10.7546 5.98927L10.2546 5.46927C10.1213 5.33594 10.0213 5.20927 9.95464 5.09594C9.9013 5.00927 9.8813 4.93594 9.8813 4.86927C9.8813 4.81594 9.9013 4.73594 9.93464 4.65594C9.9813 4.54927 10.0546 4.42927 10.148 4.3026L11.6946 2.11594C11.7613 2.0226 11.8413 1.95594 11.9413 1.90927C12.048 1.8626 12.1613 1.83594 12.2746 1.83594ZM6.7013 10.0093L6.80797 10.4626L6.62797 9.99594C6.6613 9.98927 6.68797 9.99594 6.7013 10.0093Z" fill="#62D0B6" />
                            <path d="M3.66667 6.4974C3.94 6.4974 4.16667 6.27073 4.16667 5.9974C4.16667 5.7574 4.40667 5.2574 4.80667 4.83073C5.2 4.41073 5.63333 4.16406 6 4.16406C6.27333 4.16406 6.5 3.9374 6.5 3.66406C6.5 3.39073 6.27333 3.16406 6 3.16406C5.35333 3.16406 4.67333 3.51073 4.08 4.14406C3.52667 4.7374 3.16667 5.46406 3.16667 5.9974C3.16667 6.27073 3.39333 6.4974 3.66667 6.4974Z" fill="#62D0B6" />
                            <path d="M1.33333 6.5026C1.60667 6.5026 1.83333 6.27594 1.83333 6.0026C1.83333 3.7026 3.7 1.83594 6 1.83594C6.27333 1.83594 6.5 1.60927 6.5 1.33594C6.5 1.0626 6.27333 0.835938 6 0.835938C3.15333 0.835938 0.833333 3.15594 0.833333 6.0026C0.833333 6.27594 1.06 6.5026 1.33333 6.5026Z" fill="#62D0B6" />
                        </svg>

                        <p className='gray-text !text-[12px] sm:!text-[14px] ms-2 sm:ms-5'>+966556754472</p>

                    </div>

                    <div className='flex items-center ms-7 line-4 relative'>

                        <FontAwesomeIcon icon={faEnvelope} className='icone me-2 sm:m3-5'></FontAwesomeIcon>

                        <p className='gray-text !text-[12px] sm:!text-[14px]'>Support@salla.sa</p>

                    </div>

                </div>

                <div className='hidden lg:flex items-center'>

                    <div className='flex items-center ms-7 relative cursor-pointer' onClick={e => {
                        // To ensure cansel Click on the parent element
                        e.stopPropagation();
                        setActiveMnueLang(true);
                    }}>

                        <div className='w-[20px] h-[20px] flex items-center justify-center rounded-full overflow-hidden me-3'>

                            <img src={`https://github.com/ProNabowy/countries_Flags/blob/main/${localStorage.getItem('lang') || 'Arabic'}.png?raw=true`} className='w-[20px] object-cover h-[20px]' />

                        </div>

                        <p className='gray-text'>{choosedLang || 'العربية - رس'}</p>

                    </div>
                    <Link to={'favorites'} className='hidden lg:flex items-center ms-7 line-4 relative'>

                        <p className='gray-text'>المفضلة</p>

                    </Link>
                    <Link to={'privacy'} className='hidden lg:flex items-center ms-7 line-4 relative'>

                        <p className='gray-text'>سياسة الإستبدال أو الاسترجاع</p>

                    </Link>
                    <Link to={'contact-us'} className='hidden lg:flex items-center ms-7 line-4 relative'>

                        <p className='gray-text'>تواصل معنا</p>

                    </Link>

                </div>

                {/* To Display The Languages Table */}
                <Languages activeMnueLang={activeMnueLang}></Languages>


            </div>


        </div>
    )
}
